<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南 </div>
    </div>
    <div class="auto padding250">
      <div class="container clearfix">
        <div class="left pull-left">
          <div class="list">
            <div class="wrap">
               <p class="title">老学员换证</p>
               <p class="desc">各省市物业协会颁发的项目经理证书需要先登记证书信息，经确认后可获得参加全部统一项目经理证书换证考试资格。</p>
               <router-link to="/renzheng">换证</router-link>
            </div>
          </div>
          <div class="list two">
            <div class="wrap">
               <p class="title">新学员报考</p>
               <p class="desc">各省市物业协会颁发的项目经理证书需要先登记证书信息，经确认后可获得参加全部统一项目经理证书换证考试资格。</p>
               <router-link to="/baokao">报考</router-link>
            </div>
          </div>
        </div>
        <div class="right pull-left">
          <p class="title">新学员报考及老学员换证操作指南</p>
          <p class="desc">已考取项目经理证书和已转换新证书的学员，再次报考更高级别项目经理职业资格证，需要再次通过新学员报考路径进行录入信息缴费报考，系统将自动识别个人信息，考生不能重复报考自己已有证书。</p>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 30px;
      .right{
         width: 405px;
         margin-left: 80px;
      }
      .list{
        border:1px solid #e6e6e6;
        background: url(../../assets/huanzheng.png) no-repeat right bottom;

        width: 600px;
        &:first-child{
           margin-bottom: 35px;
        }
      }
      .two{
        background: url(../../assets/baokao.png) no-repeat right bottom;
      }
      .wrap{
        padding:23px 30px;
        width: 339px;
      }
      .title{
        font-size: 20px;
        color: #000;
        font-weight: 700;
      }
      .desc{
        font-size: 14px;
        color: #999;
        line-height: 25px;
        margin: 15px 0 20px;
      }
      a{
        color: #fff;
        display: inline-block;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #0A3C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers
          
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/certificate/hangyezhengshu.vue